class ContactDetails extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.render();
    }
    
    static get observedAttributes() {
        return ['phone-label','phone','shipping'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        console.log(name, oldValue, newValue);

        if(name === 'phone-label'){
            this.phoneLabel = newValue;
        }
    
        if(name === 'phone'){
            this.phone = newValue;
        }
        if(name === 'shipping'){
            this.shipping = newValue;
        }
        this.render();
    }


    /**
     * MODIFIED by Minsan and Claude on 9/23/2026 - tracker id 55. The two header tiles were images of
     * text (J24-NBW_Blog.png "Blog" and New_to_Wigs_-_Dusty_Rose.png "New to Wigs? Start Here!"),
     * flagged by the axe guided Images test as 1.4.5. Store owner chose to remove them rather than
     * rebuild them as real text, so the whole .links block is gone from this template. The phone and
     * shipping lines above are unaffected. Note the blog is still linked twice from the main menu;
     * /pages/beginner-basics now has no link on the homepage and is reached from /pages/guides.
     */
    render() {
      this.shadowRoot.innerHTML = `
        <style>
        .contact-details-container{
          display:none;
        }
          @media screen and (min-width: 811px){
            .contact-details-container{
                display: flex;
                flex-direction: column;
                text-align: right;
            }
          }
            
            
        </style>
        <div class="contact-details-container">
          <span>${this.getAttribute('phone-label')}: <strong>${this.getAttribute('phone')}</strong></span>
          <span>${this.getAttribute('shipping')}</span>
        </div>`;
    }
  }
  
  // Define the new element
  console.log("Define the ContactDetails element")
  customElements.define('contact-details', ContactDetails);
  console.log("Element ContactDetails Defined")
  
  setTimeout(async () => {
  
  },500)
  